<template>
  <!--
      作者 gmshop
      时间：2012-12-5
      描述：设置-设置
  -->
  <div class="product-add" v-loading="loading">
    <!--form表单-->
    <el-form size="small" ref="form" :model="form" label-width="150px" v-if="!loading">
      <!--添加门店-->
      <div class="common-form">见单级差奖励设置</div>
      <el-form-item label="是否开启见单级差奖励：">
        <el-radio-group v-model="form.is_open">
          <el-radio :label="0">关闭</el-radio>
          <el-radio :label="1">开启</el-radio>
        </el-radio-group>
      </el-form-item>
      


    <div style="clear: both; height: 100px;width: 100rpx;"></div>


      <!-- region_agent -->
      <!--提交-->
      <div class="common-button-wrapper">
        <el-button type="primary" @click="onSubmit" :loading="loading">提交</el-button>
      </div>
    </el-form>
  </div>

</template>

<script>
  import GradeprofitsApi from '@/api/gradeprofits.js';
  import { formatModel } from '@/utils/base.js';
  export default {
    components:{},
    data() {
      return {
        /*是否正在加载*/
        loading: true,
        /*form表单数据*/
        form: {
          is_open: 0,
          type: 0,
          award: 0,//统一奖励
        },
        grade_list: [],
      };
    },
    created() {
      this.getParams()
    },

    methods: {

      /*获取配置数据*/
      getParams() {
        let self = this;
        GradeprofitsApi.getSetting({}, true)
          .then(res => {
            self.form = res.data.setting;
            // self.form = formatModel(self.form, vars);
            // self.form.is_open = vars.is_open || self.form.is_open;
            // self.form.type = vars.type || self.form.type;
            // self.form.award = vars.award || self.form.award;

            // self.grade_list = res.data.grade_list;
            self.loading=false;
          })
          .catch(error => {
            self.loading=false;
          });
      },

      /*转JSON字符串*/
      convertJson(list) {
        let obj = {};

        list.forEach(item => {
          obj[item.grade_id] = item.award;
        });

        return JSON.stringify(obj);
      },

      /*提交*/
      onSubmit() {
        let self = this;
        let params = this.form;
        // params.award_detail = self.convertJson(self.grade_list);
        self.$refs.form.validate((valid) => {
          if (valid) {
            self.loading = true;
            GradeprofitsApi.saveSetting(params, true)
              .then(data => {
                self.loading = false;
                self.$message({
                  message: '恭喜你，设置成功',
                  type: 'success'
                });
              })
              .catch(error => {
                self.loading = false;
              });
          }
        });
      },
      //监听复选框选中
      handleCheckedGetLog(e) {

      },
    }

  };
</script>
<style>
  .tips {
    color: #ccc;
  }
</style>



// WEBPACK FOOTER //
// src/views/plus/gradeprofits/setting/index.vue